import React from "react";
import EntityCrudPage from "../../appcomponents/EntityCrudPage";

const fields = [
  { name: "title", label: "Title", placeholder: "Tag title", autoSlugFrom: "title", required: true },
  { name: "description", label: "Description", type: "textarea", placeholder: "Short description", fullWidth: true },
  { name: "slug", label: "Slug", placeholder: "tag-slug" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
    ],
  },
];

const columns = [
  { key: "title", label: "Title" },
  { key: "description", label: "Description", render: (row) => row.description || "-" },
  { key: "slug", label: "Slug" },
  { key: "status", label: "Status" },
  { key: "author", label: "Author", render: (row) => row.author || "-" },
];

export default function Tags() {
  return (
    <EntityCrudPage
      title="Tag"
      endpoint="/api/tags.php"
      fields={fields}
      columns={columns}
      selectable
      viewFields={[...fields, { name: "author", label: "Author" }]}
      permissionPage="tags"
    />
  );
}
